import { allColors } from 'src/constants/designSystemColors';
import SkeletonValuePlaceholder from '../SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import { twMerge } from 'tailwind-merge';
import { IconProps } from '@drift-labs/icons';
import Countup from '../Utils/Countup';

const BannerInfoBox = ({
	Icon,
	label,
	value,
	countUp,
	loading,
	skeletonClassName,
	innerClassName,
}: {
	Icon: (props: IconProps) => JSX.Element;
	label: string;
	value?: React.ReactNode; // Use the value prop to pass in a value to display when the countUp end value is zero
	countUp?: {
		end: number;
		className?: string;
		durationSeconds?: number;
		formattingFn?: (value: number) => string;
	};
	loading?: boolean;
	skeletonClassName?: string;
	innerClassName?: string;
}) => {
	return (
		<div className="flex items-center">
			<Icon className="mr-[10px]" size={36} />
			<div className={twMerge('flex flex-col text-left', innerClassName)}>
				<span className="text-xs" style={{ color: allColors.neutrals[20] }}>
					{label}
				</span>
				{loading && (
					<SkeletonValuePlaceholder className={skeletonClassName} loading />
				)}
				{!loading && (
					<span
						className={twMerge(
							"text-lg text-white leading-5 font-['Chakra_Petch'] font-bold"
						)}
					>
						<span>
							{countUp ? (
								<Countup
									value={countUp.end}
									formattingFn={countUp?.formattingFn}
									className={countUp?.className}
								/>
							) : (
								<span>{value ?? countUp?.end}</span>
							)}
						</span>
					</span>
				)}
			</div>
		</div>
	);
};

export default BannerInfoBox;
